import { FieldProps } from './constants'
import { useTranslation } from 'react-i18next'
import { TextField } from '@calabriocloud/beacon-ui'

export const ClassifierTextField = ({ classifier, field, onChange }: FieldProps) => {
  const { t } = useTranslation()
  const baseValue = { classifierType: classifier.id, fieldKey: null }
  const fieldText = field?.field ?? ''
  const labelText = t(classifier.name)

  return (
    <div className='flex flex-row gap-4 pb-4'>
      <TextField label={labelText} value={fieldText} data-testid='classifier-text-input' onChange={value => onChange({
        ...baseValue,
        field: value,
        name: `${labelText} ${value}`,
      })}/>
    </div>
  )
}
